var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FM_page-404"},[_c('h1',{staticClass:"text-light"},[_vm._v("404")])])}]

export { render, staticRenderFns }